import { render, staticRenderFns } from "./OrganizationRoleInfo.vue?vue&type=template&id=9be56c78&"
import script from "./OrganizationRoleInfo.vue?vue&type=script&lang=ts&"
export * from "./OrganizationRoleInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports